import React, { AnchorHTMLAttributes } from 'react'
import classNames from 'classnames'

import { BaseButton, BaseButtonProps, BaseButtonContent } from './BaseButton'
import { toSafeUrl } from '../utils/useSafeUrl'

export type ButtonHTMLLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> &
  Omit<BaseButtonProps, 'children'> & { href: string }

export const ButtonHTMLLink = ({
  variant,
  size,
  icon,
  iconPosition,
  iconSize,
  iconClassName,
  children,
  disabled,
  className: _className,
  isActive,
  ...props
}: ButtonHTMLLinkProps) => {
  const safeUrl = toSafeUrl(props.href)
  const isBlankTarget = !!props.target && props.target === '_blank'

  return (
    <BaseButton
      variant={variant}
      size={size}
      disabled={disabled}
      isActive={isActive}
    >
      {(className) => (
        <a
          {...props}
          href={safeUrl?.toString()}
          className={classNames(className, _className)}
          rel={isBlankTarget ? 'noopener noreferrer' : props.rel}
        >
          <BaseButtonContent
            icon={icon}
            content={children}
            size={size}
            iconClassName={iconClassName}
            iconPosition={iconPosition}
            iconSize={iconSize}
          />
        </a>
      )}
    </BaseButton>
  )
}
